import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Button, Upload, message } from 'antd'
import _ from 'lodash'
import { SendEmailIcon } from '../../icons'
import BasicForm from '../../formV4' //BasicForm
import { basicInfo } from '../../../models/client.form'
import {
  introductoryEmailInfo,
  introductoryAddressInfo,
  introductoryEmergencyInfo,
  introductoryInsuranceInfo
} from '../../../models/clientIntroductory.form'
import {
  saveAvatar,
  saveIntroductory,
  sendLogisticsEmail
} from '../../../api/people'
import { editClient } from '../../../api/team'

import { userInfoStyle, style } from './index.sass'

import editIcon from '../../../asserts/icon/icon-profile-edit.svg'

class UserInfo extends Component {
  static propTypes = {
    user: PropTypes.object,
    updateSync: PropTypes.func,
    loginRole: PropTypes.string
  }

  state = {
    editing: false,
    logisticsSent: false,
    logisticsLoading: false,
    editedUserInfo: null
  }

  senEmail = async () => {
    this.setState({ logisticsLoading: true })
    try {
      await sendLogisticsEmail(this.state.user.id)
      message.success('Email sent succeed!')
      this.setState({ logisticsLoading: false, logisticsSent: true })
    } catch (err) {
      this.setState({ logisticsLoading: false })
    }
  }

  getBase64 = (img, callback) => {
    const reader = new FileReader()
    reader.addEventListener('load', () => callback(reader.result))
    reader.readAsDataURL(img)
  }

  customRequest = (request) => {
    const { file } = request
    this.getBase64(file, (imageUrl) => {
      this.changeAvatar(file)
    })
  }

  changeAvatar = async (file) => {
    const { updateSync, user } = this.props
    if (file) {
      let result = await saveAvatar(file, user.id)
      let person = result.data.person
      this.setState({ user: person })
      if (updateSync) {
        updateSync(person)
      }
    }
  }

  convertEmailParams = (params) => {
    const { introductory } = this.props
    let schedulingEmails = _.get(introductory, 'has_scheduling_email', false)
      ? _.get(introductory, 'scheduling_emails', [])
      : []

    let billingEmails = _.get(introductory, 'has_billing_email', false)
      ? _.get(introductory, 'billing_emails', [])
      : []

    _.forIn(params, function(value, key) {
      if (key.startsWith('schedulingEmail_') && value) {
        if (schedulingEmails[key.slice(-1)]) {
          schedulingEmails[key.slice(-1)].email = value
        } else {
          schedulingEmails[key.slice(-1)] = {
            email: value
          }
        }
      } else if (key.startsWith('billingEmail_') && value) {
        if (billingEmails[key.slice(-1)]) {
          billingEmails[key.slice(-1)].email = value
        } else {
          billingEmails[key.slice(-1)] = {
            email: value
          }
        }
      }
    })

    return {
      personParam: {
        email: params.email
      },
      emailParam: {
        has_scheduling_email: schedulingEmails.length > 0,
        scheduling_emails: schedulingEmails,
        has_billing_email: billingEmails.length > 0,
        billing_emails: billingEmails
      }
    }
  }

  cancelEdit = () => {
    this.basicFormRef.resetFields()
    this.emailFormRef.resetFields()
    this.addressFormRef.resetFields()
    this.insuranceFormRef && this.insuranceFormRef.resetFields()
    this.setState({ editing: false })
  }

  submit = async () => {
    const { updateSync, user, introductory } = this.props
    this.setState({ updating: true })
    try {
      const params = _.cloneDeep(await this.basicFormRef.handleSubmit())
      const emailParams = await this.emailFormRef.handleSubmit()
      const { personParam, emailParam } = this.convertEmailParams(emailParams)
      _.assign(params, personParam)
      let addressParams = await this.addressFormRef.handleSubmit()
      addressParams = _.pickBy(addressParams, (obj) => obj.address)
      const emergencyParams = await this.emergencyFormRef.handleSubmit()
      let insuranceParams = {}
      if (this.insuranceFormRef) {
        insuranceParams = await this.insuranceFormRef.handleSubmit()
      }
      const editProfileResult = await editClient(params, user.id)

      if (introductory) {
        await saveIntroductory(
          introductory.id,
          _.assign(addressParams, emergencyParams, emailParam, insuranceParams)
        )
      }

      // saveUser(result.team.person)
      this.setState({
        updating: false,
        editing: false,
        user: editProfileResult.team.person
      })
      if (updateSync) {
        updateSync(editProfileResult.team.person)
      }
    } catch (err) {
      console.error(err)
      this.setState({ updating: false, needupdateHeader: true })
    }
  }

  componentDidMount() {
    const { user } = this.props
    if (user) {
      user.profile.date_of_birth = (user.profile.date_of_birth || '').substr(
        0,
        10
      )
    }

    this.setState({ user, editedUserInfo: user })
  }

  render() {
    const { loginRole, introductory } = this.props
    const {
      editing,
      user,
      logisticsSent,
      logisticsLoading,
      editedUserInfo
    } = this.state

    const formData = basicInfo({
      editing,
      loginRole
    })

    const { emailFormData, emailValue } = introductoryEmailInfo({
      disabled: !editing,
      email: _.get(user, 'email', null),
      introductory: _.cloneDeep(introductory)
    })

    const { addressFormData } = introductoryAddressInfo({
      disabled: !editing,
      introductory
    })

    const { emergencyFormData } = introductoryEmergencyInfo({
      disabled: !editing
    })

    const insuranceInfo = introductoryInsuranceInfo(editing)

    if (loginRole === 'Expert' || loginRole === 'InternalAdmin') {
      formData.push({
        type: 'select',
        label: 'MEMBERSHIP',
        dbField: ['profile', 'membership'],
        colSpan: 12,
        disabled: !editing,
        options: [
          // {
          //   value: 'evaluation',
          //   label: 'Healthspan Assessment-Deprecated'
          // },
          {
            value: 'body recomposition',
            label: 'Body Recomposition'
          },
          {
            value: 'evaluation2',
            label: 'Healthspan Assessment'
          },
          {
            value: 'gold',
            label: 'Gold Membership'
          },
          {
            value: 'silver',
            label: 'Silver Membership'
          },
          {
            value: 'bronze',
            label: 'Bronze Membership'
          },
          {
            value: 'remote',
            label: 'Remote Membership'
          },
          {
            value: 'remote lite',
            label: 'Remote Lite Membership'
          },
          {
            value: 'core',
            label: 'Core A La Carte'
          },
          {
            value: 'core+',
            label: 'Core'
          },
          {
            value: 'lite',
            label: 'Apeiron Lite'
          },
          {
            value: 'module',
            label: 'Module Membership'
          }
        ]
      })
      formData.push({
        type: 'select',
        options: [
          {
            value: 'annually',
            label: 'Annually'
          },
          {
            value: 'quarterly',
            label: 'Quarterly',
            disabled:
              editedUserInfo &&
              (editedUserInfo.profile.membership === 'evaluation' ||
                editedUserInfo.profile.membership === 'evaluation2')
          }
        ],
        dbField: ['profile', 'billing_preference'],
        label: 'BILLING PREFERENCE',
        disabled: (loginRole || 'User') === 'User' || !editing,
        colSpan: 12
      })
    }

    return (
      <div className={style}>
        <div className="title">
          <span>Profile</span>
          {(loginRole === 'Expert' || loginRole === 'InternalAdmin') && (
            <Button
              type="primary"
              onClick={this.senEmail}
              disabled={logisticsSent}
              loading={logisticsLoading}
            >
              <SendEmailIcon />
              Send Onboarding Flow
            </Button>
          )}
        </div>
        <div className={userInfoStyle}>
          <div className="box-view user-avatar-container">
            {user && user.avatar && user.avatar.oss_url ? (
              <img
                src={user && user.avatar && user.avatar.oss_url}
                alt=""
                className="user-avatar"
              />
            ) : (
              <div className="user-avatar" style={{ background: '#E5E5E5' }} />
            )}
            {loginRole !== 'Expert' && (
              <Upload
                name="avatar"
                customRequest={this.customRequest}
                showUploadList={false}
              >
                <Button className="box-button">Change my photo</Button>
              </Upload>
            )}
          </div>
          {user && (
            <div className="box-view user-info-box">
              <div className="user-basic-info">
                <div className="top">
                  <span className="title">Basic Information</span>
                  {editing ? (
                    <div className="edit">
                      <span
                        onClick={this.cancelEdit}
                        style={{
                          color: 'rgba(38, 67, 130, 0.5)',
                          marginRight: 22
                        }}
                      >
                        Cancel
                      </span>
                      <span onClick={() => this.submit()}>Done</span>
                    </div>
                  ) : (
                    <div
                      className="edit"
                      onClick={() => {
                        this.setState({ editing: true })
                      }}
                    >
                      <img
                        src={editIcon}
                        alt=""
                        style={{
                          marginRight: 14,
                          paddingBottom: 3
                        }}
                      />
                      Edit
                    </div>
                  )}
                </div>
                <BasicForm
                  formData={formData}
                  normalLayout
                  initialValues={user}
                  wrappedComponentRef={(inst) => (this.basicFormRef = inst)}
                  onChange={(changeValue, AllValues) => {
                    this.setState({ editedUserInfo: AllValues })
                    if (changeValue.profile && changeValue.profile.membership) {
                      if (
                        changeValue.profile.membership.includes('evaluation')
                      ) {
                        this.basicFormRef.setFieldValue(
                          ['profile', 'billing_preference'],
                          'annually'
                        )
                      }
                    }
                  }}
                />
              </div>
              <div className="user-basic-info">
                <div className="top">
                  <span className="title">email information </span>
                </div>
                {introductory && (
                  <BasicForm
                    formData={emailFormData}
                    normalLayout
                    initialValues={emailValue}
                    wrappedComponentRef={(inst) => (this.emailFormRef = inst)}
                  />
                )}
              </div>

              <div className="user-basic-info">
                <div className="top">
                  <span className="title">address information </span>
                </div>

                {introductory && (
                  <BasicForm
                    formData={addressFormData}
                    normalLayout
                    initialValues={introductory}
                    wrappedComponentRef={(inst) => (this.addressFormRef = inst)}
                  />
                )}
              </div>

              <div className="user-basic-info">
                <div className="top">
                  <span className="title">emergency contact </span>
                </div>
                {introductory && (
                  <BasicForm
                    formData={emergencyFormData}
                    normalLayout
                    initialValues={introductory}
                    wrappedComponentRef={(inst) =>
                      (this.emergencyFormRef = inst)
                    }
                  />
                )}
              </div>

              {(introductory && (_.get(introductory, 'insurance_type') === 'manual' || (introductory.insurance_photos && introductory.insurance_photos.some(photo => photo.type === 'upload')))) && (
                <div className="user-basic-info">
                  <div className="top">
                    <span className="title">Insurance Information</span>
                  </div>

                  {_.get(introductory, 'insurance_type') === 'manual' && (
                    <BasicForm
                      normalLayout
                      formData={insuranceInfo}
                      initialValues={introductory}
                      wrappedComponentRef={(inst) =>
                        (this.insuranceFormRef = inst)
                      }
                    />
                  )}

                  {introductory.insurance_photos && introductory.insurance_photos.some(photo => photo.type === 'upload') && (
                    introductory.insurance_photos.filter(photo => photo.type === 'upload').map((photo, index) => (
                      <div key={index} className="insurance-photo">
                        <img src={photo.oss_url} alt={`Insurance ${index + 1}`} style={{ maxWidth: '50%', maxHeight: '300px', marginBottom: '10px' }} />
                      </div>
                    ))
                  )}
                </div>
              )}

            </div>
          )}
        </div>
      </div>
    )
  }
}

export default UserInfo
